import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {JobsDataService} from '../../../modules/jobs/jobs-data.service';
import {ApplicationModel} from '../../../shared/models/application.model';
import {NgForm} from '@angular/forms';
import {UserDataService} from '../../../modules/auth/user-data.service';
import {format, parseISO} from 'date-fns';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'app-single-application',
    templateUrl: './single-application.component.html',
    styleUrls: ['./single-application.component.scss'],
})

export class SingleApplicationComponent implements OnInit {
    application;
    applicationId: string;
    jobAppLoaded = false;
    backButtonUrl: string;
    interviewIsSet = false;
    userRole = '';
    setDate = '';
    pageTitle = '';
    candidate;
    formResponse: boolean;
    formSent: boolean;
    appStatus: string;
    token: string;
    jobDetails:any;

    interviewCallDate: any;

    constructor(private route: ActivatedRoute, private jobsDataService: JobsDataService, private userData: UserDataService, private router: Router) {
    }
    // Constants
    CLIENT_ID = '896572705207-ip6cdt8clcdvgl773q6c1lvpdv8okgcq.apps.googleusercontent.com';
    API_KEY = 'AIzaSyAal5ooBXwg0wXsPfL6FSSfX5iEVt9VONU';
    DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest';
    // SCOPES = 'https://www.googleapis.com/auth/calendar.app.created';
    SCOPES = 'https://www.googleapis.com/auth/calendar';

    tokenClient: any;
    gapiInited = false;
    gisInited = false;

    loadGoogleAPIs() {
        // @ts-ignore
        gapi.load('client', this.initializeGapiClient.bind(this));
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.onload = () => this.gisLoaded();
        document.head.appendChild(script);
    }
    initializeGapiClient() {
        // @ts-ignore
        gapi.client.init({
            apiKey: this.API_KEY,
            discoveryDocs: [this.DISCOVERY_DOC],
        }).then(() => {
            this.gapiInited = true;
            this.maybeEnableButtons();
        });
    }

    gisLoaded() {
        // @ts-ignore
        this.tokenClient = google.accounts.oauth2.initTokenClient({
            client_id: this.CLIENT_ID,
            scope: this.SCOPES,
            callback: this.handleTokenCallback.bind(this)
        });
        this.gisInited = true;
        this.maybeEnableButtons();
    }

    handleTokenCallback(resp: any) {
        console.log('Access Token:', resp);
        console.log('Access Token:', resp.access_token);

        if (resp.error !== undefined) {
            throw (resp);
        }

        this.setEventData(resp.access_token)

        document.getElementById('signout_button').style.visibility = 'visible';
        document.getElementById('authorize_button').innerText = 'Refresh';


    }

    maybeEnableButtons() {
        if (this.gapiInited && this.gisInited) {
            document.getElementById('authorize_button').style.visibility = 'visible';
        }
    }

    handleAuthClick(interviewCallDate: NgForm) {
        if (this.tokenClient) {
            this.interviewCallDate = interviewCallDate.value.interviewDate;
            // @ts-ignore
            if (gapi.client.getToken() === null) {
                this.tokenClient.requestAccessToken({ prompt: 'consent' });
                // @ts-ignore
                console.log(gapi.client.getToken(), 'here?');
            } else {
                this.tokenClient.requestAccessToken({ prompt: '' });
                // @ts-ignore
                console.log(gapi.client.getToken());
            }
        }
    }

    handleSignoutClick() {
        // @ts-ignore
        const token = gapi.client.getToken();
        if (token !== null) {
            // @ts-ignore
            google.accounts.oauth2.revoke(token.access_token);
            // @ts-ignore
            gapi.client.setToken('');
            document.getElementById('authorize_button').innerText = 'Authorize';
            document.getElementById('signout_button').style.visibility = 'hidden';
        }
    }

    setEventData(googleToken: any){

                const startDate = format(parseISO(this.interviewCallDate), 'dd-MMM-yyyy HH:mm:ss');
                const eventData = {
                    summary: 'Interviu angajare',
                    description: `Interviu ${this.application.userFirstName} ${this.application.userLastName} pentru ${this.application.applicationDetail.jobName}`,
                    eventStartDate: startDate,
                    eventEndDate: startDate,
                    userId: this.userData.userData.userId,
                    jobApplicationId: this.applicationId,
                    accessToken: googleToken,
                    candidateEmail: this.candidate.email,
                    googleMeetLink: 'string',
                }

                this.jobsDataService.createEvent(eventData).subscribe(googleEvent => {
                    console.log(googleEvent, 'event');
                    this.jobsDataService.getApplication(this.applicationId).subscribe(reloadAppData => {
                        this.application = reloadAppData;
                    })
                })

    }

    async ngOnInit() {

        this.loadGoogleAPIs();

        this.route.params.subscribe((params: Params) => {
            this.applicationId = params.id;

            this.jobsDataService.getApplication(this.applicationId)
            .pipe(
                catchError(error => {
                    // Handle the error here, e.g., show an error message and redirect the user
                    console.log('Error fetching application:');
                    // Redirect the user to an error page or a specific URL
                    this.router.navigate(['/autentificare']); // Example redirection to an error page
                    return throwError(error); // Rethrow the error after handling
                })
            )
            .subscribe(res => {
                console.log('app', res);
                this.application = res;
                this.jobAppLoaded = true;
                this.userRole = this.userData.userRole;

                if (this.userRole === 'client') {
                    this.backButtonUrl = '/aplicatii/' + this.application.jobId;
                    this.pageTitle = `Aplicatie ${this.application.userFirstName} ${this.application.userLastName}`;

                } else {
                    this.backButtonUrl = '/aplicatiile-mele';
                    this.pageTitle = `Aplicatie ${this.application.applicationDetail.jobName}`;
                }

                if (this.application.statusApplication.interviewDate !== null) {
                    this.interviewIsSet = true;
                }

                this.jobsDataService.getCurrentJob(this.application.jobId).subscribe(jobData=>{
                    this.jobDetails=jobData;
                    console.log(this.jobDetails);
                })

                this.userData.getUserById(this.application.userId).subscribe(candidate => {
                    this.candidate = candidate;
                })

            })
        })

    }


    sendComment(messageForm: NgForm) {
        const message = messageForm.form.value.message;
        this.jobsDataService.addCommentToApplication(this.applicationId, message).subscribe(commentPosted => {
            if (commentPosted) {
                const newComment = {
                    message,
                    messageDate: new Date()
                }
                this.application.applicationMessages.push(newComment);
                messageForm.resetForm();
            }
        })
    }

    changeAppStatus(e) {
        const statusApplication = {
            responseStatus: e.target.value,
            interviewDate: this.application.interviewDate,
            hasInterviewDate: this.application.interviewDate,
            jobClosed: this.application.jobClosed,
            statusMessage: this.application.statusMessage
        }

        this.jobsDataService.changeApplicationStatus(this.applicationId, statusApplication).subscribe(result => {
        })
    }
}
